export interface SalesOrderLineSummaryTop {
  id: string;
  salesOrderAndLineNo: string;
  customerKey: string;
  customerName: string;
  productId: string;
}
